module.exports = __webpack_public_path__ + "img/teams-grid-zoom-minus.0bf1bc08.svg";